import { activeModule } from './activeModule'
import { addSSOKeys } from './addSSOKeys'
import { createNewTennant } from './createNewTennant'
import { getAccessStats } from './getAccessStats'
import { getAIUsage } from './getAIUsage'
import { getBySlug } from './getBySlug'
import { getConfigs } from './getConfigs'
import { getPublicConfigs } from './getPublicConfigs'
import { getTennants } from './getTennants'
import { updateCommunicationSettings } from './updateCommunicationSettings'
import { updateMaxUsers } from './updateMaxUsers'

export const tenantService = {
  getBySlug,
  getConfigs,
  getPublicConfigs,
  getTennants,
  activeModule,
  addSSOKeys,
  getAIUsage,
  createNewTennant,
  getAccessStats,
  updateMaxUsers,
  updateCommunicationSettings,
}
